import {
  Button,
  Flex,
  IconArrowOpenDownLine,
  IconArrowOpenUpLine,
  IconButton,
  IconTrashLine,
  Modal,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { memo, useContext, useState } from "react";
import { ApDataContext } from "../../../../views/Plan";
import { Card } from "../../../Card";
import { SINGLE, Selector } from "../../../Selectors/Selector";
import { MeasureForm } from "../ComponentForms/MeasureForm";
import { CANVAS, EMBEDDED, EXTERNAL, QUALITATIVE } from "../utils";

const MeasurePickerCard = memo(({ measure, lastMeasure }) => {
  const { t } = useTranslation();
  const { measureIndex, sectionIndex, setSections, extraData } =
    useContext(ApDataContext);
  const [openModal, setOpenModal] = useState(false);

  const handleTypeSelect = (type) => {
    setSections((prev) =>
      prev.map((section, i) =>
        i === sectionIndex
          ? {
              ...section,
              measures: section.measures.map((m, j) =>
                j === measureIndex ? { ...m, type } : m
              ),
            }
          : section
      )
    );
  };

  const moveMeasureUp = () => {
    setSections((prev) =>
      prev.map((section, i) =>
        i === sectionIndex
          ? {
              ...section,
              measures: section.measures.map((m, j) =>
                j === measureIndex
                  ? section.measures[measureIndex - 1]
                  : j === measureIndex - 1
                    ? section.measures[measureIndex]
                    : m
              ),
            }
          : section
      )
    );
  };

  const moveMeasureDown = () => {
    setSections((prev) =>
      prev.map((section, i) =>
        i === sectionIndex
          ? {
              ...section,
              measures: section.measures.map((m, j) =>
                j === measureIndex
                  ? section.measures[measureIndex + 1]
                  : j === measureIndex + 1
                    ? section.measures[measureIndex]
                    : m
              ),
            }
          : section
      )
    );
  };

  const handleDeleteMeasure = () => {
    setSections((prev) =>
      prev.map((section, i) =>
        i === sectionIndex
          ? {
              ...section,
              measures: section.measures.filter((_, j) => j !== measureIndex),
            }
          : section
      )
    );
  };

  return (
    <Card style={{ backgroundColor: "#FFFFFF", padding: "0" }}>
      <Flex wrap="wrap" padding="small">
        <Flex.Item size="50%">
          <Selector
            type={SINGLE}
            id={`assessment-type-select-section-${sectionIndex}-measure-${measureIndex}`}
            label={t("measures.typeOf")}
            options={[
              { id: CANVAS, label: t("assessment.canvasAssessment") },
              { id: EXTERNAL, label: t("assessment.externalAssessment") },
              { id: QUALITATIVE, label: t("assessment.qualitativeMeasure") },
              { id: EMBEDDED, label: t("embeddedDashboard.embeddedDashboard") },
            ]}
            selectHandler={handleTypeSelect}
            selectedItemId={measure.type}
            size="small"
          />
        </Flex.Item>
        <Flex.Item align="start" shouldGrow textAlign="end">
          <IconButton
            renderIcon={IconArrowOpenUpLine}
            screenReaderLabel={t("measures.moveMeasureUp")}
            size="small"
            onClick={moveMeasureUp}
            disabled={measureIndex === 0}
          />
          <IconButton
            renderIcon={IconArrowOpenDownLine}
            screenReaderLabel={t("measures.moveMeasureDown")}
            size="small"
            onClick={moveMeasureDown}
            margin="0 0 0 small"
            disabled={!!lastMeasure}
          />
          <IconButton
            color="danger"
            renderIcon={IconTrashLine}
            screenReaderLabel={t("measures.delete")}
            size="small"
            onClick={handleDeleteMeasure}
            margin="0 0 0 small"
          />
        </Flex.Item>
      </Flex>
      <Modal.Footer>
        <Button color="primary" size="small" onClick={() => setOpenModal(true)}>
          {t("planTemplates.build")}
        </Button>
      </Modal.Footer>
      <MeasureForm
        openModal={openModal}
        setOpenModal={setOpenModal}
        templateFields={measure}
        courseLevels={extraData.courseLevels}
        assignmentTypes={extraData.assignmentTypes}
        acSubs={extraData.acSubs}
        planId={extraData.plan?.id}
        allCycles={extraData.cycles}
        programs={extraData.programs}
        inCreate
      />
    </Card>
  );
});

export default MeasurePickerCard;
